import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FormDataConsumer, required, SelectArrayInput, SelectInput } from 'react-admin';
import TooltipHelper from './TooltipHelper';

const styles = theme => ({
  input: {
    width: '550px',
  },
  root: {
    padding: '20px',
    marginLeft: '40px',
  },
});

export const getLangsIdsWithoutSpecified = (langs, id) => (langs || []).filter(lang => lang !== id);
export const getLangsWithoutSpecified = (langs, id) => (langs || []).filter(lang => lang.id !== id);

const Languages = ({ classes, ...props }) => (
  <div className={classes.root}>
    <SelectInput className={classes.input} label="Default language" data-testid="default-language" source="defaultLang" optionText="name"
      optionValue="id" choices={props.languages} initialValue="/languages/EN" validate={required()}/>
    <TooltipHelper
      title="Set the language to match your website. For websites with multiple languages, set the main language to your website's source language."
      placement="right"/>
    <FormDataConsumer>
      {({ formData }) => {
        if (formData) {
          formData.languages = getLangsIdsWithoutSpecified(formData.languages || [], formData.defaultLang);
          return <div>
            <SelectArrayInput className={classes.input} label="Additional languages" data-testid="additional-language"
              source="languages" optionText="name" optionValue="id"
              choices={getLangsWithoutSpecified(props.languages, formData.defaultLang)}/>
            <TooltipHelper title="Select additional languages matching the language versions of your website." placement="right"/>
          </div>;
        }
      }}
    </FormDataConsumer>

  </div>
);

export default withStyles(styles)(Languages);
